import { forwardRef, useMemo, Children, useState, createElement } from 'react';
import { Root } from '@radix-ui/react-dialog';
import { DialogContext } from './Context.js';
import { Trigger } from './components/Trigger.js';
import { Content, Title, Footer, Close } from './components/Content.js';
import { Drawer } from './components/Drawer.js';
import { Extra } from './components/Extra.js';

const useSeparatedChildren = initialChildren => {
  return useMemo(() => {
    const children = [];
    let drawer;
    let extra;
    Children.toArray(initialChildren).forEach(child => {
      var _child$type, _child$type2;

      if (((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === Drawer.displayName) {
        drawer = child;
      } else if (((_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === Extra.displayName) {
        extra = child;
      } else {
        children.push(child);
      }
    });
    return [children, drawer, extra];
  }, [initialChildren]);
};

const Dialog = /*#__PURE__*/forwardRef(function Dialog(props, ref) {
  const {
    children: initialChildren,
    closeOnEscape = true,
    defaultOpen,
    draggable = false,
    onChange,
    onClose,
    open,
    showCloseButton = true,
    size = 'sm',
    trigger,
    ...otherProps
  } = props;
  const [children, drawer, extra] = useSeparatedChildren(initialChildren);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const context = useMemo(() => ({
    closeOnEscape,
    draggable,
    drawer: {
      open: drawerOpen,
      toggle: () => setDrawerOpen(isDrawerOpen => !isDrawerOpen)
    },
    elements: {
      drawer,
      extra
    },
    onClose,
    props: otherProps,
    showCloseButton,
    size,
    ref
  }), [closeOnEscape, drawerOpen, draggable, drawer, extra, open, otherProps, showCloseButton]);
  return createElement(DialogContext.Provider, {
    value: context
  }, createElement(Root, {
    defaultOpen: defaultOpen,
    open: open,
    onOpenChange: onChange
  }, trigger && createElement(Trigger, null, trigger), children));
});
Dialog.Trigger = Trigger;
Dialog.Content = Content;
Dialog.Title = Title;
Dialog.Footer = Footer;
Dialog.Extra = Extra;
Dialog.Drawer = Drawer;
Dialog.Close = Close;

export { Dialog };
//# sourceMappingURL=Dialog.js.map
